<app-header></app-header>

<section class="partner-blog single-page partner-patient-profile bg-grey padd-row">
  <div class="container">
      <div class="parnter-blog-main bg-white">

          <div class="partner-patient-profile-heading">
              <div class="row">
                <div class="col-md-6"> 

                        <div class="doctor-box">
                                <div class="doctor-box-top">
                                    <div class="doctor-box-img">
                                        <img [src]="loginData.profilePicture" alt="image">
                                    </div>
                                    <div class="doctor-box-top-cnt">
                                        <h5> {{ loginData.name ? loginData.name : 'User' }} <span>{{ loginData.phoneNo!='' ? loginData.phoneNo : '' }}</span> <span>  {{ loginData.gender + '|' ? loginData.gender :'' }} {{ loginData.age ? loginData.age + 'Years Old' : '' }}</span></h5>
                                        <div class="doc-box-btm-btns">
                                            <!-- <a href="javascript://" class="btn-style no-shadow"> Call </a> -->
                                            <!-- <a [routerLink]="['/Doctor/doctor-chat/'+patientId]" class="btn-style btn-style-border no-shadow"> Message </a> -->
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                </div>
                <div class="col-md-6 text-right"> 
                        <div class="doctor-box-upload-img-new">
                               <!-- + <input style="display:none;" (change)="fileChanged($event)" type="file" accept="image/*" #filerecord> -->
                              <button (click)="openRecordPopup()" data-toggle="modal" data-target="#uploadReportModel" >Upload Medical Record</button></div>

                </div>

              </div>
              
             
          </div>
         
         
          <div class="partner-patient-profile-body">
              <!-- Nav tabs -->
              <ul class="nav nav-tabs">
                  <li class="nav-item">
                      <a class="nav-link active" data-toggle="tab" href="#menu1"> Bookings </a>
                  </li>
                  <li class="nav-item">
                      <a class="nav-link" data-toggle="tab" href="#menu2">Doctor Prescriptions </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#menu4">Hospital Prescriptions </a>
                </li>
                  <li class="nav-item">
                      <a class="nav-link" data-toggle="tab" href="#menu3"> Medical Records </a>
                  </li>
              </ul>

              <!-- Tab panes -->
              <div class="patient-prefile-tabs-cnt">
                  <div class="tab-content">
                      <div class="tab-pane active" id="menu1">
                          <div class="patient-profile-bookings">
                              <div class="table-responsive">
                                  <table class="table table-borderless">
                                      <thead>
                                          <tr>
                                              <th> Booking Date </th>
                                              <th> Doctor Details </th>
                                              <th> Treatments </th>
                                              <th> Total Amount </th>
                                              <th> Chat </th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr *ngFor="let booking of doctorBookings" class="tr-bdr">
                                              <td>
                                                  <p class="book-date"> {{ booking?.date  }} {{ booking?.month  }},{{ booking?.year  }}</p>
                                                  <p> <span [innerHTML]="convertTime(booking.startTime)">  </span> </p>
                                              </td>
                                              <td>
                                                  <p><a [routerLink]="['/doctors/detail/'+booking?.doctorId?.uniquekey]"> {{ booking?.doctorId?.name }}</a> </p>
                                                  <p> {{ booking?.doctorId?.phoneNo }} </p>
                                                  <address> {{ booking?.doctorId?.address }}<br> {{ booking?.doctorId?.city }} </address>
                                              </td>
                                              <td>
                                                  <p *ngFor="let treatment of booking?.treatments"> {{ treatment.name }} </p>
                                                 
                                              </td>
                                              <td>
                                                  <p> Rs. {{ booking?.totalPrice | number:'1.00-0' }}/- </p>
                                                  <p class="color-blue" *ngIf="booking?.status=='PENDING'"> YOUR APPOINTMENT IS WAITING FOR APPROVAL </p>
                                                  <p class="color-blue" *ngIf="booking?.status=='APPROVE'"> YOUR APPOINTMENT IS CONFIRMED </p>
                                                  <p class="color-blue" *ngIf="booking?.status=='COMPLETE'"> YOUR APPOINTMENT HAS BEEN  COMPLETED </p>
                                              </td>
                                              <td>   <a *ngIf="booking?.doctorId" [routerLink]="['/chat/'+booking?.doctorId?._id]" class="btn-style btn-style-border"> Chat </a></td>
                                          </tr>
                                        
                                  </table>
                              </div>
                          </div>
                      </div>
                      <div class="tab-pane fade" id="menu2">
                          <div class="patient-profile-perscriptions">
                              <div class="row">
                                  <div [hidden]="prescription?.status=='PENDING' || prescription?.status=='APPROVE'"  *ngFor="let prescription of doctorBookings let i=index" class="col-lg-6">
                                      <div class="lab-ordr-list-box lab-details-test-box">
                                          <span id="precriptions-btn-show-cnt" (click)="toggle(i)" class="precriptions-btn-show-cnt"> <i class="fa fa-chevron-down" aria-hidden="true"></i> </span>
                                          <div class="lab-details-test-box-top-cnt">
                                              <div class="d-flex">
                                                  <h5> Prescription {{ i+1 }} </h5>
                                                  <div class="price"> Rs. {{ prescription.totalPrice }}/- </div>
                                              </div>
                                          </div>
                                          <div class="lab-details-test-box-btm-cnt">
                                              <div class="d-flex">
                                                  <div class="patient-perscirpt-lft-text">
                                                      <p> <strong> Doctor info : </strong></p>
                                                      <p> Name : <a [routerLink]="['/doctors/detail/'+prescription?.doctorId?.uniquekey]"> {{ prescription?.doctorId?.name }}</a> </p>
                                                      <p> Registered Doctor <img style="width:30px;height:30px" src="assets/images/bluetick.png"> </p>
                                                      <p> Phone Number : {{  prescription?.doctorId?.phoneNo }} </p>
                                                  </div>
                                                  <div class="patient-perscirpt-rght-text" id="patient-prs-breif-txt">
                                                      <p> <strong> {{ prescription?.treatments?.length }} Treatments </strong></p>
                                                      <p> <span>   {{ prescription?.date  }} {{ prescription?.month }},{{ prescription?.year }}</span></p>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="patient-perscriptions-hidden-text" [id]="'prcritpins-hidden-cnt-'+i" style="display: none;">
                                                <div class="patient-desc-modal">
                                                        <div class="table-responsive">
                                                         <table class="table table-bordered">
                                                                 <thead>
                                                                   <tr>
                                                                     <th>S No.</th>
                                                                     <th>Medicine</th>
                                                                     <th>Dosage</th>
                                                                     <th>Instructions</th>
                                                                  
                                                                   </tr>
                                                                 </thead>
                                                                 <tbody>
                                                                   <tr *ngFor="let description of prescription?.description let k=index" >
                                                                     <td>{{ k+1 }}</td>
                                                                     <td>{{ description?.split('^%')[0] }} </td>
                                                                     <td>{{ description?.split('^%')[1] }}</td>
                                                                     <td>{{ description?.split('^%')[2] }}</td>
                                                                  
                                                                   </tr>
                                                                    
                                                                 </tbody>
                                                               </table> 
                                                     
                                         
                                                             </div>
                                                    </div>

                                              <p> <span> {{ prescription?.prescription ? prescription?.prescription : 'No Prescription' }}. </span></p>
                                              <ul class="clearfix">
                                                  <li *ngFor="let treatment of prescription.treatments"> 
                                                 <strong> {{ treatment?.name }} </strong> Rs. {{ treatment?.price }}/- </li>
                                                
                                              </ul>
                                              <div class="patient-perscriptions-hidden-text-ftr">
                                                  <h4>
                                                      TOTAL AMOUNT
                                                      <div class="price"> Rs. {{ prescription.totalPrice }}/- </div>
                                                  </h4>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                               
                              </div>
                          </div>
                      </div>
                      <div class="tab-pane fade" id="menu4">
                          <div class="patient-profile-perscriptions">
                              <div class="row">
                                  <div [hidden]="prescription?.status=='PENDING' || prescription?.status=='APPROVE'"  *ngFor="let prescription of hospitalBookings let i=index" class="col-lg-6">
                                      <div class="lab-ordr-list-box lab-details-test-box">
                                          <span id="precriptions-btn-show-cnt" (click)="toggleHospital(i)" class="precriptions-btn-show-cnt"> <i class="fa fa-chevron-down" aria-hidden="true"></i> </span>
                                          <div class="lab-details-test-box-top-cnt">
                                              <div class="d-flex">
                                                  <h5> Prescription {{ i+1 }} </h5>
                                                  <div class="price"> Rs. {{ prescription.totalPrice }}/- </div>
                                              </div>
                                          </div>
                                          <div class="lab-details-test-box-btm-cnt">
                                              <div class="d-flex">
                                                  <div class="patient-perscirpt-lft-text">
                                                      <p> <strong> Hospital info : </strong></p>
                                                      <p> Name :  <a [routerLink]="['/hospitals/detail/'+prescription?.hospitalId?._id]">{{ prescription?.hospitalId?.name }}</a> </p>
                                                      <p> Registered Hospital <img style="width:30px;height:30px" src="assets/images/bluetick.png"> </p>
                                                      <p> Phone Number : {{  prescription?.hospitalId?.phoneNo }} </p>
                                                  </div>
                                                  <div class="patient-perscirpt-rght-text" id="patient-prs-breif-txt">
                                                      <p> <strong> {{ prescription?.treatments?.length }} Treatments </strong></p>
                                                      <p> <span>   {{ prescription?.date  }} {{ prescription?.month }},{{ prescription?.year }}</span></p>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="patient-perscriptions-hidden-text" [id]="'prcritpins-hidden-cnt-hsp-'+i" style="display: none;">
                                                <div class="patient-desc-modal">
                                                        <div class="table-responsive">
                                                         <table class="table table-bordered">
                                                                 <thead>
                                                                   <tr>
                                                                     <th>S No.</th>
                                                                     <th>Medicine</th>
                                                                     <th>Dosage</th>
                                                                     <th>Instructions</th>
                                                                  
                                                                   </tr>
                                                                 </thead>
                                                                 <tbody>
                                                                   <tr *ngFor="let description of prescription?.description let k=index" >
                                                                     <td>{{ k+1 }}</td>
                                                                     <td>{{ description?.split('^%')[0] }} </td>
                                                                     <td>{{ description?.split('^%')[1] }}</td>
                                                                     <td>{{ description?.split('^%')[2] }}</td>
                                                                  
                                                                   </tr>
                                                                    
                                                                 </tbody>
                                                               </table> 
                                                     
                                         
                                                             </div>
                                                    </div>

                                              <p> <span> {{ prescription?.prescription ? prescription?.prescription : 'No Prescription' }}. </span></p>
                                              <ul class="clearfix">
                                                  <li *ngFor="let treatment of prescription.treatments"> 
                                                 <strong> {{ treatment?.name }} </strong> Rs. {{ treatment?.price }}/- </li>
                                                
                                              </ul>
                                              <div class="patient-perscriptions-hidden-text-ftr">
                                                  <h4>
                                                      TOTAL AMOUNT
                                                      <div class="price"> Rs. {{ prescription.totalPrice }}/- </div>
                                                  </h4>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                               
                              </div>
                          </div>
                      </div>
                      <div class="tab-pane fade" id="menu3">
                          <div class="patient-profile-medical-records">

                                <div class="row">
                                        <div class="col-md-3  mb-4" *ngFor="let report of reports let i=index">
                                          <div class="medical-his-box">
                                                <img style="cursor:pointer" (click)="openImage(report.image)" *ngIf="report.type=='image'"  [src]="report.image" alt="doc">
                                                <a [download]="report.image" *ngIf="report.type=='pdf' && report.image" target="_blank" [href]="report.image"><img style="cursor:pointer"    [src]="'assets/images/pdf.jpeg'" alt="doc"></a>
                                             <div *ngIf="report.image" class="medical-his-box-cnt d-flex">
                                                <h4> {{ report.title }} </h4> 
                                              <i class="fa fa-trash" (click)="deleteRecord(i,report.image)"></i>
                                             </div>
                                         </div>
                                       </div>
                                     </div>
                           
                          </div>
                      </div>
                  </div>
              </div>

          </div>

      </div>

  </div>
</section>

<input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade"  id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Medical Record</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
            <slideshow
            [minHeight]="'525px'"
            [showArrows]="false"
            [imageUrls]="imageUrlArray"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;"
 data-toggle="modal" data-target="#orderImagesModal">OK</button>

      </div>
    </div>
  </div>
</div>


<input type="file" #fileInput style="display:none;" (click)="fileInput.value = null" value="" required (change)="fileChanged($event)" #reportFile accept=".png, .jpg, .jpeg, .pdf">

<input type="hidden" id="uploadReportClick" data-toggle="modal" data-target="#uploadReportModel" data-toggle="modal" data-target="#uploadReportModel">
<div class="modal fade"  id="uploadReportModel">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upload Report</h5>
        </div>
        <!-- Modal body -->
        <div class="modal-body text-center">
            <form class="doctors-edit-main p-0 no-shadow">
                <div class="doctors-edit-lft">
                    <div class="edit-profile-form-rows">
                        <div class="row no-gutters">
                                <div class="col-md-12">
                                        <label> Title </label>
                                        <input type="text" name="testTitle" class="form-control"  [(ngModel)]="report.title" placeholder="Enter Title">
                                    </div>
                                    <div class="col-md-12">
                                            <label> Report Type </label>
                                            <select  name="reportType" [(ngModel)]="report.type" class="form-control" >
                                                <option value="pdf">PDF</option>
                                                <option value="image">Image</option>
                                                </select>
                                        </div>
                                        
                            <div class="col-md-12">
                                    <a [routerLink]="null"   (click)="reportFile.click();" class="btn-style btn-style-border">Upload Report</a>
                                <img *ngIf="showImage" [src]="report.image">
                            </div>
                          
                            
                            <div class="col-md-12">
                                <div class="add-doc-btns-btm mt-3">
                                    <!-- <button type="submit"    class="btn-style no-shadow"> Save </button>
                                    <button type="button"  class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </button> -->
                                    <a [routerLink]="null" (click)="updateDocuments()" class="btn-style no-shadow"> Save </a>
                                    <a href="javascript://" class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
          <!-- <button class="btn btn-primary" style="margin-top: 20px;" data-toggle="modal" data-target="#uploadReportModel">Upload</button> -->
  
        </div>
      </div>
    </div>
  </div>


